import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ContentBlocks from '~/client/components/content-blocks/content-blocks';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import type { PressArticle as Props } from './press-article.types';

const PressArticle: React.FC<Props> = ({
  blocks,
  body,
  debug,
  image,
  layout,
  metadata,
  summary,
  title,
}) => (
  <Layout {...layout}>
    <div className="press-article">
      {image ? (
        <div className="press-article__image">
          <img src={image.src} alt={image.alt ? image.alt : ''} />
        </div>
      ) : null}
      <div className="press-article__content">
        <ContentContainer>
          <div className="press-article__title">
            <Text
              elementName="h1"
              size={Text.sizes.headline1}
              theme={Text.themes.headline}
              tight
            >
              {title}
            </Text>
          </div>
        </ContentContainer>
        {summary ? (
          <ContentContainer theme={ContentContainer.themes.medium}>
            <div className="press-article__summary">
              <Text elementName="p" size={Text.sizes.large} tight>
                {summary}
              </Text>
            </div>
          </ContentContainer>
        ) : null}
        <ContentContainer theme={ContentContainer.themes.medium}>
          <div className="press-article__metadata">
            <Text
              elementName="span"
              size={Text.sizes.interface}
              theme={Text.themes.headline}
              tight
            >
              {metadata[0]}
            </Text>
            <Text elementName="span" size={Text.sizes.interface} tight>
              {metadata[1]}
            </Text>
          </div>
        </ContentContainer>
        <ContentContainer theme={ContentContainer.themes.medium}>
          <div
            className="press-article__body"
            dangerouslySetInnerHTML={{ __html: body }}
          />
        </ContentContainer>
      </div>
      {blocks ? (
        <ContentContainer theme={ContentContainer.themes.wide}>
          <ContentBlocks {...blocks} />
        </ContentContainer>
      ) : null}
      {debug ? (
        <ContentContainer>
          <div style={{ overflow: 'auto' }}>
            <code>
              <pre>{debug}</pre>
            </code>
          </div>
        </ContentContainer>
      ) : null}
    </div>
  </Layout>
);

export default PressArticle;
